/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/no-agb-accepted/app.no-agb-accepted.component.ts.
 */
import {Component} from '@angular/core';
import {AppConfigService} from '../../services/app.config.service';

/**
 * Zweck: Beschreibt class AppNoAgbAcceptedComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    // moduleId: module.id,
    selector: 'app-no-agb-accepted',
    templateUrl: 'app.no-agb-accepted.component.html',
    styleUrls: ['app.no-agb-accepted.component.scss'],
    standalone: false
})
export class AppNoAgbAcceptedComponent {
  static id = 'AppNoAgbAcceptedComponent';

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public cfg: AppConfigService) {
  }
}
